import { render, staticRenderFns } from "./beneficiarioFormAlterarResponsavel.vue?vue&type=template&id=4d6e561b&scoped=true&"
import script from "./beneficiarioFormAlterarResponsavel.vue?vue&type=script&lang=js&"
export * from "./beneficiarioFormAlterarResponsavel.vue?vue&type=script&lang=js&"
import style0 from "./beneficiarioFormAlterarResponsavel.vue?vue&type=style&index=0&id=4d6e561b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e561b",
  null
  
)

export default component.exports